export default __webpack_public_path__ + "static/media/家庭寄养勋章@2x.dd94af95.png";